import React from 'react'
import ReactDOM from 'react-dom'
import Root from './containers/root'
ReactDOM.render(<Root />, document.getElementById('root'))
